import { render, staticRenderFns } from "./FormErrorPage.vue?vue&type=template&id=be9e30ac&scoped=true"
import script from "./FormErrorPage.vue?vue&type=script&lang=ts"
export * from "./FormErrorPage.vue?vue&type=script&lang=ts"
import style0 from "./FormErrorPage.vue?vue&type=style&index=0&id=be9e30ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9e30ac",
  null
  
)

export default component.exports